import { GroupDelegate } from '@leverege/molten/imagine';
import { GlobalState } from '@leverege/ui-redux';
import { Dialogs } from '@leverege/ui-elements';
import Upsell from '../r4k/views/Upsell';
const LOCATION_TO_MUTATE = {
  'blueprint.link.location.keys.GroupScreen': true,
  'blueprint.link.location.tags.GroupScreen': true,
  'blueprint.link.company.locations.keys.GroupScreen': true,
  'blueprint.link.company.locations.tags.GroupScreen': true,
  'blueprint.link.location.gateways.GroupScreen': true,
  'blueprint.link.company.locations.gateways.GroupScreen': true
};
const COMPANY_TO_MUTATE = {
  'blueprint.link.company.keys.GroupScreen': true,
  'blueprint.link.company.tags.GroupScreen': true,
  'blueprint.link.company.gateways.GroupScreen': true
};
const VEHICLES_TO_UPDATE = {
  'blueprint.link.company.locations.vehicles.keys.GroupScreen': true,
  'blueprint.link.location.vehicles.keys.GroupScreen': true,
  'blueprint.link.company.vehicles.keys.GroupScreen': true
};
const UPSELL = {
  'blueprint.link.location.keys.GroupScreen': true,
  'blueprint.link.company.keys.GroupScreen': true,
  'blueprint.link.company.locations.keys.GroupScreen': true
};
export default function keysLinksMutator(type, plugin, molten) {
  if (type === 'Action') {
    const uiName = molten.getConfig('uiName');
    if (LOCATION_TO_MUTATE[plugin.id]) {
      return {
        ...plugin,
        handles: cxt => {
          if (UPSELL[plugin.id] && uiName === 'ui') {
            return plugin.handles(cxt);
          }
          const {
            clientProps
          } = cxt;
          return !!clientProps?.item?.data?.keysEnabled && plugin.handles(cxt);
        },
        perform: props => {
          const {
            context
          } = props;
          const {
            clientProps
          } = context;
          if (clientProps?.item?.data?.keysEnabled) {
            return plugin.perform(props);
          }
          return Dialogs.show({
            id: 'key-upsell-dialog',
            component: Upsell
          });
        }
      };
    }
    if (COMPANY_TO_MUTATE[plugin.id]) {
      return {
        ...plugin,
        handles: cxt => {
          if (UPSELL[plugin.id] && uiName === 'ui') {
            return plugin.handles(cxt);
          }
          const {
            clientProps
          } = cxt;
          const {
            delegate
          } = clientProps;
          const locations = getLocationsDelegate(delegate).getList(undefined, {
            getAll: true
          })?.items;
          return locations?.some(location => location.data?.keysEnabled) && plugin.handles(cxt);
        },
        prepare: cxt => {
          const {
            clientProps
          } = cxt;
          const {
            delegate
          } = clientProps;
          return GlobalState.dispatch(getLocationsDelegate(delegate).search());
        },
        isPrepared: cxt => {
          const {
            clientProps
          } = cxt;
          const {
            delegate
          } = clientProps;
          return getLocationsDelegate(delegate).getList(undefined, {
            getAll: true
          }) != null;
        },
        perform: props => {
          const {
            context
          } = props;
          const {
            clientProps
          } = context;
          const {
            delegate
          } = clientProps;
          const locations = getLocationsDelegate(delegate).getList(undefined, {
            getAll: true
          })?.items;
          if (locations?.some(location => location.data?.keysEnabled)) {
            return plugin.perform(props);
          }
          return Dialogs.show({
            id: 'key-upsell-dialog',
            component: Upsell
          });
        }
      };
    }
    if (VEHICLES_TO_UPDATE[plugin.id]) {
      return {
        ...plugin,
        handles: cxt => {
          const {
            clientProps
          } = cxt;
          const {
            parentItem,
            delegate
          } = clientProps;
          if (parentItem?.type === 'location') {
            return parentItem.data.data?.keysEnabled;
          }
          if (parentItem?.type === 'company') {
            // eslint-disable-next-line max-len
            const locations = getLocationsDelegate(delegate.parent().parent()).getList(undefined, {
              getAll: true
            })?.items;
            return locations?.some(location => location.data.keysEnabled) && plugin.handles(cxt);
          }
          return true;
        },
        prepare: cxt => {
          const {
            clientProps
          } = cxt;
          const {
            parentItem,
            delegate
          } = clientProps;
          if (parentItem.type === 'location') {
            return Promise.resolve();
          }
          return GlobalState.dispatch(getLocationsDelegate(delegate.parent().parent()).search());
        },
        isPrepared: cxt => {
          const {
            clientProps
          } = cxt;
          const {
            delegate,
            parentItem
          } = clientProps;
          if (parentItem.type === 'location') {
            return true;
          }
          return getLocationsDelegate(delegate.parent().parent()).getList(undefined, {
            getAll: true
          }) != null;
        }
      };
    }
  }
  return plugin;
}
function getLocationsDelegate(delegate) {
  let locationsDelegate = delegate.child('locations');
  locationsDelegate = new GroupDelegate({
    relationship: locationsDelegate.relationship,
    match: locationsDelegate.match,
    queryName: `${delegate.relationship.path}.locations.search.keysMutation`
  });
  return locationsDelegate;
}